import axios, { AxiosRequestConfig } from 'axios'
import { camelCaseObjectKeys } from '@doordash/object-utils'
import { dxApiUrl } from '.'
import { bffOpts } from './config'

export type CheckEmailIsAssociatedWithDasherSuccessPayload = {
  shouldForwardToLogin: boolean
  applicantUniqueLink: string
}

export const checkEmailIsAssociatedWithDasher = async (
  email: string
): Promise<CheckEmailIsAssociatedWithDasherSuccessPayload> => {
  const opts: AxiosRequestConfig = { baseURL: dxApiUrl() }
  const url = `/v4/dasher_applicants/${email}/should_forward_to_login`
  try {
    const response = await axios.get(url, opts)
    return camelCaseObjectKeys(response.data)
  } catch (error) {
    throw error
  }
}

export const sendSmsRecovery = async (phoneNumber: string): Promise<{}> => {
  const url = `/v4/dasher_applicants/reclaim_email`
  const response = await axios.post(
    url,
    {
      phone_number: phoneNumber,
    },
    bffOpts
  )
  return camelCaseObjectKeys(response.data)
}

export type ShouldTriggerSMSPayload = {
  shouldTriggerSms: boolean
}

export const shouldTriggerSms = async (
  phoneNumber: string
): Promise<ShouldTriggerSMSPayload> => {
  const url = '/v4/dasher_applicants/should_trigger_sms'
  const response = await axios.post(
    url,
    {
      phone_number: phoneNumber,
    },
    bffOpts
  )
  return camelCaseObjectKeys(response.data)
}
